import React from 'react';
import DownloadCsvButton from '../DownloadCsvButton';
import { exportPropertiesToCsv } from '../../../services/propertiesCsvExportService';

const DownloadPropertiesCsvButton = () => (
    <DownloadCsvButton
        labelKey="app.page.product.property.downloadCSV"
        onExport={exportPropertiesToCsv}
    />
);

export default DownloadPropertiesCsvButton;
